import React  from "react";
import 'moment/locale/pt-br';

//Context
import AuthProvider from "context/auth";
import RoutesComponent from "RoutesComponent";

export default function App() {
    return (
        <AuthProvider>
            <RoutesComponent/>
        </AuthProvider>
    )
}
